import { defineMessages } from 'react-intl'

const scope = `procurify.expenses.SettingsExpenseFormPage`

export default defineMessages({
  pageTitle: {
    id: `${scope}.pageTitle`,
    defaultMessage: 'Customize request for expense form',
  },
  settingsBreadcrumb: {
    id: `${scope}.settingsBreadcrumb`,
    defaultMessage: 'Settings',
  },
})
